// 261010 UI-directing — «tài sản bổ sung» ở bước 3 Đạo diễn: chỉ MỘT dòng, và chỉ khi đuôi Đạo diễn thật sự cần người (tài sản lỗi / bị chặn / chưa rõ kết quả). THUẦN (không antd).
// Không bao giờ liệt kê từng mục («Video · chờ», «Mục · đang chạy»…) và không vẽ ảnh tài sản đã xong ở đây — việc xử lý nằm ở bước 2 «Tài sản».
import type { WorkflowStatus } from '../../types/filmWorkflow';
import { flagInfoOf } from './workflowFlagUtils';

/** Mục tài sản của đuôi Đạo diễn (dòng «cần thêm N tài sản» đã nói) — dòng tóm tắt lỗi của bước không lặp lại. */
export const isTailAssetObject = (ownerType: string | undefined, key: string): boolean => ownerType === 'look' || ownerType === 'location' || ownerType === 'prop' || ASSET_KEY.test(key);

const ASSET_KEY = /^(?:missing:)?(?:look|location|prop):|^kyc:|^plan:asset-tail$/;

export interface DirectingTailLine { count: number; text: string }

/** Số tài sản mà lượt Đạo diễn cần thêm và đang kẹt (kind ERROR theo flagInfoOf: FAILED / BLOCKED / UNCERTAIN / NOT_RUN_*). Đang chờ / đang chạy / xong / giữ sửa tay ⇒ không tính. */
export function directingTailLineOf(status: WorkflowStatus | null | undefined): DirectingTailLine | null {
  const seen = new Set<string>();
  for (const o of status?.stepRuns?.DIRECTING?.objects ?? []) {
    const isAsset = isTailAssetObject(o.ownerType, o.key);
    if (!isAsset) continue;
    if (flagInfoOf({ outcome: o.outcome, code: o.error?.code, message: o.error?.message }).kind !== 'ERROR') continue;
    seen.add(o.key);
  }
  const count = seen.size;
  return count > 0 ? { count, text: `Đạo diễn cần thêm ${count} tài sản` } : null;
}
